import { IAction } from '~/src/store';

import { ETicketPayment } from './index';

export type TSetIsFetching = IAction<ETicketPayment.SET_IS_FETCHING, boolean>

const setIsFetching = (isFetching: boolean): TSetIsFetching => ({
    type: ETicketPayment.SET_IS_FETCHING,
    payload: isFetching,
});

export default setIsFetching;
